var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 16.3333V39.6667C49 46.6667 45.5 51.3333 37.3333 51.3333H18.6667C10.5 51.3333 7 46.6667 7 39.6667V16.3333C7 9.33332 10.5 4.66666 18.6667 4.66666H37.3333C45.5 4.66666 49 9.33332 49 16.3333Z",
    fill: "#3ECAE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1666 21.5833H38.5C34.9533 21.5833 32.0833 18.7133 32.0833 15.1667V10.5C32.0833 9.54333 32.8766 8.75 33.8333 8.75C34.79 8.75 35.5833 9.54333 35.5833 10.5V15.1667C35.5833 16.7767 36.89 18.0833 38.5 18.0833H43.1666C44.1233 18.0833 44.9166 18.8767 44.9166 19.8333C44.9166 20.79 44.1233 21.5833 43.1666 21.5833Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32.0833H18.6667C17.71 32.0833 16.9167 31.29 16.9167 30.3333C16.9167 29.3767 17.71 28.5833 18.6667 28.5833H28C28.9567 28.5833 29.75 29.3767 29.75 30.3333C29.75 31.29 28.9567 32.0833 28 32.0833Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3334 41.4167H18.6667C17.71 41.4167 16.9167 40.6233 16.9167 39.6667C16.9167 38.71 17.71 37.9167 18.6667 37.9167H37.3334C38.29 37.9167 39.0834 38.71 39.0834 39.6667C39.0834 40.6233 38.29 41.4167 37.3334 41.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentText);
export default __webpack_public_path__ + "static/media/document-text.e354b8a5c691633e1f77b6810dfc4100.svg";
export { ForwardRef as ReactComponent };